import styled from 'styled-components';
import { ButtonLink } from 'styles/elements';
import Card from 'components/Card';
import { FONT_FAMILY } from 'styles/GlobalStyle';
import { rgba } from 'styles/utils/color';

export const DescriptionText = styled.div``;

export const PricingCard = styled(Card)<{ border?: boolean }>`
  border-radius: 16px;
  border: ${({ theme, border }) => (border ? `1px solid ${theme.color.buttonPrimary}` : '')};
`;

export const CTACard = styled(PricingCard)`
  border: ${({ theme }) => `3px solid ${theme.color.buttonPrimary}`};
  background-color: ${({ theme }) => rgba(theme.color.buttonPrimary, 0.4)};
`;

export const Currency = styled.div`
  color: ${({ theme }) => theme.color.textFaded};
  position: absolute;
  left: -13px;
  top: -4px;
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
  text-align: center;
`;

export const PriceDescription = styled.div`
  color: ${({ theme }) => theme.color.textFaded};
  font-size: 13px;
  line-height: 18px;
  font-weight: 500;
  text-align: center;
`;

export const ValuePropRow = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.color.border};
`;

export const IconWrapper = styled.div`
  flex-shrink: 0;
  color: ${({ theme }) => theme.color.buttonPrimary};
  margin-right: 14px;
  font-size: 19px;
`;

export const ValuePropRowFaded = styled(ValuePropRow)`
  color: ${({ theme }) => theme.color.textMuted};
`;
export const IconWrapperFaded = styled(IconWrapper)`
  color: ${({ theme }) => theme.color.textMuted};
`;

export const CheckoutButton = styled(ButtonLink)`
  font-weight: 700;
`;

export const ContactButton = styled(CheckoutButton)`
  background-color: ${({ theme }) => theme.color.textPrimary};
  color: ${({ theme }) => theme.color.buttonPrimary};
`;

export const CTAText = styled.span`
  color: #25cf51;
`;

export const DiscountBoxWrapper = styled.div`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.color.buttonPrimary};
  font-size: 12px;
  line-height: 18px;
  padding: 14px 20px;
  font-weight: 500;
  background-color: ${({ theme }) => theme.color.backgroundDistinct};
  font-family: ${FONT_FAMILY};
`;

export const UpgradeText = styled.span`
  font-weight: 700;
  border-bottom: 4px solid ${({ theme }) => theme.color.buttonPrimary};
`;
